import request from '@/utils/request'

const basePath = "/api/resume/baseInfo";

/**
 * 保存简历基础信息
 * @param form
 */
export function saveResumeBaseInfo(form) {
    return request({
        url: `/api/resume/baseInfo/save`,
        method: 'post',
        data: form
    })
}

/**
 * 自动生成简历
 * @param form
 */
export function autoGenerateBaseInfo(resumeName) {
    return request({
        url: `/api/resume/baseInfo/auto?resumeName=${resumeName}`,
        method: 'post'
    })
}

/**
 * 修改简历基础信息
 * @param form
 */
export function updateResumeBaseInfo(form) {
    return request({
        url: `${basePath}/update`,
        method: 'put',
        data: form
    })
}

/**
 * 修改简历名称
 */
export function updateResumeName(id, resumeName) {
    return request({
        url: `/api/resume/baseInfo/resumeName/${id}?resumeName=${resumeName}`,
        method: 'put',
    });
}

/**
 * 修改简历状态
 * @param id
 * @param publicStatus
 * @param jobStatus
 */
export function updateResumeStatus(id, publicStatus, jobStatus) {
    return request({
        url: `/api/resume/baseInfo/status?id=${id}&publicStatus=${publicStatus}&jobStatus=${jobStatus}`,
        method: 'put'
    });
}

/**
 * 删除简历基础信息
 * @param id
 */
export function deleteResumeBaseInfo(id) {
    return request({
        url: `${basePath}/${id}`,
        method: 'delete',
    })
}


/**
 * 查询当前用户简历信息列表
 */
export function getBaseInfoListByCreatorId() {
    return request({
        url: `${basePath}/person/list`,
        method: 'get'
    })
}

/**
 * 保存简历基础信息联系方式
 * @param form
 */
export function saveContact(form) {
    return request({
        url: `/api/resume/baseInfo/contact/save`,
        method: 'post',
        data: form
    })
}

/**
 * 保存简历求职意向
 * @param form
 */
export function saveJobIntention(form) {
    return request({
        url: `/api/resume/baseInfo/jobIntention/save`,
        method: 'post',
        data: form
    })
}

/**
 * 保存简历工作经历
 * @param form
 */
export function saveWorkExperience(form) {
    return request({
        url: `/api/resume/workExperience/save`,
        method: 'post',
        data: form
    });
}

/**
 * 修改简历工作经历
 * @param form
 */
export function updateWorkExperience(form) {
    return request({
        url: `/api/resume/workExperience/update`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历工作经历
 * @param id
 */
export function deleteWorkExperience(id) {
    return request({
        url: `/api/resume/workExperience/delete/${id}`,
        method: 'delete',
    });
}

/**
 * 保存简历项目经历
 * @param form
 */
export function saveProjectExperience(form) {
    return request({
        url: `/api/resume/projectExperience/save`,
        method: 'post',
        data: form
    });
}

/**
 * 修改简历项目经历
 * @param form
 */
export function updateProjectExperience(form) {
    return request({
        url: `/api/resume/projectExperience/update`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历项目经历
 * @param id
 */
export function deleteProjectExperience(id) {
    return request({
        url: `/api/resume/projectExperience/delete/${id}`,
        method: 'delete',
    });
}

/**
 * 保存简历教育经历
 * @param form
 */
export function saveEducationExperience(form) {
    return request({
        url: `/api/resume/educationExperience/save`,
        method: 'post',
        data: form
    });
}

/**
 * 修改简历教育经历
 * @param form
 */
export function updateEducationExperience(form) {
    return request({
        url: `/api/resume/educationExperience/update`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历教育经历
 * @param id
 */
export function deleteEducationExperience(id) {
    return request({
        url: `/api/resume/educationExperience/delete/${id}`,
        method: 'delete',
    });
}

/**
 * 保存简历培训经历
 * @param form
 */
export function saveTrainingExperience(form) {
    return request({
        url: `/api/resume/trainingExperience/save`,
        method: 'post',
        data: form
    });
}

/**
 * 修改简历培训经历
 * @param form
 */
export function updateTrainingExperience(form) {
    return request({
        url: `/api/resume/trainingExperience/update`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历培训经历
 * @param id
 */
export function deleteTrainingExperience(id) {
    return request({
        url: `/api/resume/trainingExperience/delete/${id}`,
        method: 'delete',
    });
}

/**
 * 保存简历技能/语言
 * @param form
 */
export function saveProfessional(form) {
    return request({
        url: `/api/resume/professional/save`,
        method: 'post',
        data: form
    });
}

/**
 * 保存简历技能
 * @param form
 */
export function saveSkill(form) {
    return request({
        url: `/api/resume/skill/save`,
        method: 'post',
        data: form
    });
}

/**
 * 修改简历技能
 * @param form
 */
export function updateSkill(form) {
    return request({
        url: `/api/resume/skill/update`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历技能
 * @param id
 */
export function deleteSkill(id) {
    return request({
        url: `/api/resume/skill/delete/${id}`,
        method: 'delete',
    });
}

/**
 * 保存简历专业语言
 * @param form
 */
export function saveLanguage(form) {
    return request({
        url: `/api/resume/language`,
        method: 'post',
        data: form
    });
}

/**
 * 修改简历专业语言
 * @param form
 */
export function updateLanguage(form) {
    return request({
        url: `/api/resume/language`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历专业语言
 * @param id
 */
export function deleteLanguage(id) {
    return request({
        url: `/api/resume/language/${id}`,
        method: 'delete',
    });
}

/**
 * 保存简历证书
 * @param form
 * @param attachmentFileId
 */
export function saveCert(form, attachmentFileId) {
    return request({
        url: `/api/resume/cert/save?attachmentFileId=${attachmentFileId}`,
        method: 'post',
        data: form
    })
}

/**
 * 修改简历证书
 * @param form
 */
export function updateCert(form) {
    return request({
        url: `/api/resume/cert/update`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历证书
 * @param id
 */
export function deleteCert(id) {
    return request({
        url: `/api/resume/cert/delete/${id}`,
        method: 'delete',
    });
}

/**
 * 保存简历附件
 * @param form
 */
export function saveAttachment(form) {
    return request({
        url: `/api/resume/attachment/save`,
        method: 'post',
        data: form
    })
}

/**
 * 修改简历附件
 * @param form
 */
export function updateAttachment(form) {
    return request({
        url: `/api/resume/attachment/update`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历附件
 * @param id
 */
export function deleteAttachment(id) {
    return request({
        url: `/api/resume/attachment/delete/${id}`,
        method: 'delete',
    });
}

/**
 * 保存竞赛经历
 * @param form
 */
export function saveCompetitionExperience(form) {
    return request({
        url: `/api/resume/competitionExperience/save`,
        method: 'post',
        data: form
    })
}

/**
 * 修改简历竞赛经历
 * @param form
 */
export function updateCompetitionExperience(form) {
    return request({
        url: `/api/resume/competitionExperience/update`,
        method: 'put',
        data: form
    });
}

/**
 * 删除简历竞赛经历
 * @param id
 */
export function deleteCompetitionExperience(id) {
    return request({
        url: `/api/resume/competitionExperience/delete/${id}`,
        method: 'delete',
    });
}

/**
 * 查询推荐人才(简单数据)
 * @param form
 */
export function querySimpleResume(params) {
    return request({
        url: `${basePath}/public/simpleList/byCondition`,
        method: 'get',
        params: params
    })
}

/**
 * 查询找人才列表
 * @param form
 */
export function queryEsResumeList(params) {
    return request({
        url: `${basePath}/public/es`,
        method: 'get',
        params: params
    })
}

/**
 * 根据简历id查询简历信息(基础公开信息)
 */
export function queryResume(id) {
    //{id}
    return request({
        url: `${basePath}/public/${id}`,
        method: 'get',
    })
}

/**
 * 根据简历id查询简历信息(详细信息)
 */
export function getResume(id) {
    //{id}
    return request({
        url: `${basePath}/${id}`,
        method: 'get',
    })
}

/**
 * 修改默认简历
 * @param params
 */
export function updateResumeDefaultFlag(params) {
    return request({
        url: `${basePath}/default`,
        method: 'put',
        params: params
    })
}

/**
 * 修改企业对简历的评价
 * @param params {resumeId: "1", appraiseList: []}
 */
export function updateResumeAppraise(params) {
    return request({
        url: `${basePath}/appraise/${params.resumeId}`,
        method: 'put',
        data: params
    })
}

/**
 * 企业用户获取人才库简历分页列表
 * @param params 分页查询参数 {pageSize:10, pageNumber:1, keyword: '', jobPosition:''}
 */
export function findResumePagesByEs(params) {
    return request({
        url: `${basePath}/enterprise/es`,
        method: 'get',
        params: params
    })
}

/**
 * 查询推荐人才
 */
export function findHotBaseInfo() {
    return request({
        url: `${basePath}/baseInfo/public/hot`,
        method: 'get'
    })
}

/**
 * 批量导出简历
 * @param form
 */
export function importBaseInfo(params) {
    return request({
        url: `${basePath}/import`,
        method: 'post',
        params: params
    })
}

/**
 * 获取所有开放简历中城市中市出现的前十列表
 */
export function getPublicResumeCityTop() {
    return request({
        url: `${basePath}/public/city`,
        method: 'get'
    })
}

